/**
 * @generated SignedSource<<f147c9d4c062c047715df31bcb34fa97>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Step1SelectWorkflowListBuildkitePipelinesQuery$variables = {
  integrationId: any;
};
export type Step1SelectWorkflowListBuildkitePipelinesQuery$data = {
  readonly listBuildkitePipelines: ReadonlyArray<any>;
};
export type Step1SelectWorkflowListBuildkitePipelinesQuery = {
  response: Step1SelectWorkflowListBuildkitePipelinesQuery$data;
  variables: Step1SelectWorkflowListBuildkitePipelinesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "integrationId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "integrationId",
        "variableName": "integrationId"
      }
    ],
    "kind": "ScalarField",
    "name": "listBuildkitePipelines",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Step1SelectWorkflowListBuildkitePipelinesQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Step1SelectWorkflowListBuildkitePipelinesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b48e87bc1696139c9256c11d8c343b20",
    "id": null,
    "metadata": {},
    "name": "Step1SelectWorkflowListBuildkitePipelinesQuery",
    "operationKind": "query",
    "text": "query Step1SelectWorkflowListBuildkitePipelinesQuery(\n  $integrationId: GlobalID!\n) {\n  listBuildkitePipelines(integrationId: $integrationId)\n}\n"
  }
};
})();

(node as any).hash = "242072d1704b0685c60ff1baf3f3e316";

export default node;
